<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  
  	  <div class="backborder1">   
  	  	  <!--   	  
	  	  <el-alert type="error" description="温馨提示：应付金额 = 订单内各商品总价相加 - 优惠金额 - 退款金额 + 快递费；订单商品撤单时，若退款金额 > (应付金额-已付金额)，则退款金额为（实付金额-已付金额），反之退款金额为商品的总价；未付款的撤单不退款"></el-alert>      
	      -->
	      
	      <!------------------------search---------------------->
	      <el-form :inline="true" class="demo-form-inline" style="margin-top:15px" size="small">
	            <el-form-item style="width:9%">
		            <el-select v-model="query.clerkid" clearable filterable placeholder="全部销售员" @change="isselect=true" style="width:100%">
		                <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
		            </el-select> 
	            </el-form-item>
	            <el-form-item style="width:12%">
		            <el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" placeholder="请输入客户名称 / 简称" style="width:100%">
		          	    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
		            </el-select> 
		        </el-form-item>
	            <el-form-item style="width:9%">
		            <el-select v-model="query.account" placeholder="全部支付" clearable filterable @change="isselect=true" style="width:100%">
		                <el-option v-for="(item,index) in paylists" :key="index" :label="item.name" :value="item.id"></el-option>
		            </el-select> 
	            </el-form-item>  
	             
	            <el-form-item style="width:19%">
		            <el-date-picker
		                v-model="query.date"
		                type="daterange"
		                range-separator="至"
		                start-placeholder="开始日期"
		                end-placeholder="结束日期"
		                value-format="yyyy-MM-dd" @change="isselect=true" clearable style="width:100%">
		            </el-date-picker>
	            </el-form-item>
	            <el-form-item ref="query" :model="query" style="width:12%">
	            	<el-input placeholder="订单编号" v-model="query.key" clearable @keyup.enter.native="getList" @change="isselect=true" style="width:100%"></el-input>
	            </el-form-item>
	            <el-form-item style="width:12%;">
	            	<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	            	<el-button type="primary" @click="outputinfos">导出</el-button>
	            </el-form-item>
	            <el-form-item style="width:18%;">
	            	<div style="float:left;margin-top:-3%;">
			      	    <span style="font-size:13px;color:#E6A23C;float:left;width:100%;line-height:23px">实付金额：￥{{allstat.real}}</span>
			      	    <span style="font-size:13px;color:#E6A23C;float:left;width:100%;line-height:23px">订单总额：￥{{allstat.total}}</span>
			        </div>
	            </el-form-item>
	        </el-form>
        </div>
        <!------------------------search end---------------------->
		
		<div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listLoading">
	            <el-table-column type="expand">
		            <template slot-scope="props">
		            	<div style="width:99%;color:#606266;padding-left:1%">
	              	        <span v-if="props.row.truename!=''">联系人：{{props.row.truename}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
	              	        <span v-if="props.row.phone!=''">电话：{{props.row.phone}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
	              	        <span v-if="props.row.address!=''">地址：{{props.row.address}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
	              	        <span>备注：{{props.row.note}}</span>
	              	    </div>
		                <el-table :data="props.row.product">
			                <el-table-column prop="name" label="商品名称"></el-table-column>
			                <el-table-column prop="num" label="数量" width="100" align="center"></el-table-column>
			                <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
			                <el-table-column prop="sell" label="价格" width="100" align="center"></el-table-column>
			                <el-table-column prop="total" label="总价" width="100" align="center"></el-table-column>
			                <el-table-column prop="type" label="类型" width="100" align="center"></el-table-column>
			                <!--
			                <el-table-column label="退货" width="80">
				                <template slot-scope="scope">
				                  <el-button type="info" size="mini" icon="el-icon-minus" v-if="scope.row.status==2 && actionauth.stat_order_cancel=='true'" @click="returnCurrent(scope.row)"></el-button>
				                  <el-tag type="info" v-if="scope.row.status==3">已退</el-tag>
				                </template>
			                </el-table-column>
			                -->
		                </el-table>
		            </template>
	            </el-table-column>
	            <el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
	          	<el-table-column prop="customer" label="客户名称"></el-table-column>
	            <el-table-column prop="total" label="订单总价" align="center" width="100"></el-table-column>
	          	<el-table-column prop="real" label="应付金额" align="center" width="100"></el-table-column>
	          	<el-table-column prop="derate" label="优惠金额" align="center" width="100"></el-table-column>
	          	<el-table-column prop="amount" label="已付金额" align="center" width="100"></el-table-column>
	          	<el-table-column prop="clerk" label="销售员" align="center" width="110"></el-table-column>
	          	<el-table-column prop="accountname" label="支付" align="center" width="110"></el-table-column>
	          	<el-table-column prop="inputtime" label="订单时间" width="100" align="center"></el-table-column>
	          	<!--
	          	<el-table-column label="撤单" width="140" align="center">
		          	<template slot-scope="scope">
		          		<el-button type="primary" size="mini" icon="el-icon-document" @click="printCurrent(scope.row)"></el-button>
			            <el-button type="danger" size="mini" icon="el-icon-delete" v-if="scope.row.status==2 && actionauth.stat_order_cancel=='true'" @click="delCurrent(scope.row)"></el-button>
			            <el-tag type="info" v-if="scope.row.status==3">已撤</el-tag>
		          	</template>
	            </el-table-column>
	            -->
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
        </div>

        <!------------------------撤单---------------------->
        <el-dialog title="撤单" :visible.sync="delDialog" width="30%">
          <el-tag type="danger">未付款的订单进行退货或者撤单时，退款金额为 0</el-tag>
          <el-form ref="del" :model="del" label-width="100px" style="margin-top:15px">
              <el-col :span="22">
	              <el-form-item label="名称" prop="documents">
	                  <el-input v-model="del.documents" readonly></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="22">
	              <el-form-item label="退款金额" prop="total">
	                  <el-input v-model="del.total" readonly><template slot="append">元</template></el-input>
	              </el-form-item>
              </el-col>
              <el-col :span="22" v-if="del.total > 0">
	              <el-form-item label="退款方式">
	                  <el-select v-model="del.account">
		                  <el-option
		                    v-for="(item,index) in accountLists"
		                    :key="index"
		                    :label="item.name"
		                    :value="item.id">
		                  </el-option>
	                  </el-select>
	              </el-form-item>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="delDialog = false">取 消</el-button>
            <el-button type="primary" :loading="delLoading" @click="delSave">确 认</el-button>
          </div>
        </el-dialog>
      <!------------------------撤单 end---------------------->
      
      
      <!--------------------------------打印信息 start ------------------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="5vh">
      	  <div style="width:100%;text-align:right">每页展示  <input type="text" v-model="rollpage"  v-on:blur="changepagevlaue()"  style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px"/>  条</div>
	      <div id="printContent">
		      <div v-for="(iit,i) in prpage">
		      	  <span style="float:right">{{iit.id}}/{{allprintpage}}</span>
		      	  <DIV style="font-size:18px;padding-bottom:2px;" align="center" v-if="printsmodel.title==1"><STRONG>{{printsmodel.titlevalue}}</STRONG></DIV>        
		      	  <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%;" style="font-size:15px">
					  <TBODY>
				          <TR class="contacttitle">
				          	  <TD v-if="printsmodel.contactname==1">收货人姓名：{{print.receive_name}}</TD>
				          	  <TD v-if="printsmodel.documents==1">单据编号：{{print.documents}}</TD>
				          	  <TD v-if="printsmodel.note==1">出库备注：{{print.note}}</TD>
				          </TR>
				          <TR class="contacttitle">
				          	  <TD v-if="printsmodel.contactphone==1">收货电话：{{print.receive_phone}}</TD>
				          	  <TD v-if="printsmodel.clerkname==1">销售人员：{{print.clerkname}}</TD>
				          	  <TD v-if="printsmodel.accountname==1">支付方式：<span >{{print.account}}</span></TD>  
				          </TR>
				          <TR class="contacttitle">
				          	  <TD v-if="printsmodel.address==1" colspan="3">收货地址：{{print.receive_address}}</TD>
				          </TR>
				          <TR class="contacttitle">
					          <TD v-if="printsmodel.customer_name==1">客户名称：{{print.customername}}</TD>
					          <TD v-if="printsmodel.deliverdate==1">交货日期：{{print.deliverdate}}</TD>
					          <TD></TD>
					      </TR>
		          	  </TBODY>
		      	  </TABLE>
		      	  <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse;font-size:15px" bordercolor="#333333">
			      	  <TR class="contactcontent">
			          	  <TD v-if="printsmodel.number==1"><DIV align=center><b>编号</b></DIV></TD>
			              <TD v-if="printsmodel.product_name==1"><DIV align=center><b>品名</b></DIV></TD>
			              <TD v-if="printsmodel.product_spec==1"><DIV align=center><b>规格</b></DIV></TD>
			              <TD v-if="printsmodel.unit==1"><DIV align=center><b>单位</b></DIV></TD>
			              <TD v-if="printsmodel.num==1"><DIV align=center><b>数量</b></DIV></TD>
			              <TD v-if="printsmodel.sell==1"><DIV align=center><b>售价</b></DIV></TD>
			              <TD v-if="printsmodel.discount==1"><DIV align=center><b>折扣</b></DIV></TD>
			              <TD v-if="printsmodel.dis_sell==1"><DIV align=center><b>折后单价</b></DIV></TD>
			              <TD v-if="printsmodel.market==1"><DIV align=center><b>零售价</b></DIV></TD>  
			              <TD v-if="printsmodel.account==1"><DIV align=center><b>小计</b></DIV></TD>
			              <TD v-if="printsmodel.warehourse==1"><DIV align=center><b>仓库</b></DIV></TD>
			              <TD v-if="printsmodel.desc==1"><DIV align=center><b>备注</b></DIV></TD>
			              <TD v-if="printsmodel.type==1"><DIV align=center><b>类型</b></DIV></TD>
			          </TR>
				      <TR v-for="(item,index) in print.goods" :key="index" class="contactcontent" v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage'] ">
				      	  <TD v-text="item.number" align="center" v-if="printsmodel.number==1"></TD>
				          <TD v-text="item.name" style="padding-left:1%" v-if="printsmodel.product_name==1"></TD>
				          <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec==1"></TD>
				          <TD v-text="item.unit" align="center" v-if="printsmodel.unit==1"></TD>
				          <TD v-text="item.num" align="center" v-if="printsmodel.num==1"></TD>
				          <TD v-text="item.sell" align="center" v-if="printsmodel.sell==1"></TD>
				          <TD v-text="item.discount" align="center" v-if="printsmodel.discount==1"></TD>
				          <TD v-text="item.dis_sell" align="center" v-if="printsmodel.dis_sell==1"></TD>
				          <TD v-text="item.market" align="center" v-if="printsmodel.market==1"></TD>
				          <TD v-text="item.total" align="center" v-if="printsmodel.account==1"></TD>
				          <TD v-text="item.warehousename" align="center" v-if="printsmodel.warehourse==1"></TD>
				          <TD v-text="item.desc" style="padding-left:1%" v-if="printsmodel.desc==1"></TD>
				          <TD v-text="item.type" align="center" v-if="printsmodel.type==1"></TD>
		          	  </TR>
		          	  <tr v-if="iit.id==allprintpage">
				      	  <TD align="center" v-if="printsmodel.number==1 || printsmodel.product_name==1"><b>合计</b></TD>
				          <TD v-if="printsmodel.number==1 && printsmodel.product_name==1"></TD>
				          <TD v-if="printsmodel.product_spec==1">&nbsp;</TD>
				          <TD v-if="printsmodel.unit==1">&nbsp;</TD>
				          <TD v-if="printsmodel.num==1">&nbsp;</TD>
				          <TD v-if="printsmodel.sell==1">&nbsp;</TD>
				          <TD v-if="printsmodel.discount==1">&nbsp;</TD>
				          <TD v-if="printsmodel.dis_sell==1">&nbsp;</TD>
				          <TD v-if="printsmodel.market==1">&nbsp;</TD>
				          <TD align="center" v-if="printsmodel.account==1">{{print.real}}</TD>
				          <TD v-if="printsmodel.warehourse==1">&nbsp;</TD>
				          <TD v-if="printsmodel.desc==1">&nbsp;</TD>
				          <TD v-if="printsmodel.type==1">&nbsp;</TD>
		          	  </tr>
		      	  </TABLE>		      	  
		      	  
		      	  <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="font-size:15px">
				      <TR class="top1">
					  	  <TD v-if="printsmodel.inputdate==1">录单日期：{{print.inputtime}}</span></TD>
					      <TD v-if="printsmodel.derate==1">优惠金额：{{print.derate}} 元</TD>
					      <TD v-if="printsmodel.total==1">实付金额：{{print.real}} 元</TD>
					      <TD v-if="printsmodel.sysmanagername==1">操作人：{{print.sysmanager}}</TD>
				      </tr>
					  <TR class="top1" v-if="printsmodel.print==1"">
					      <TD :colspan="4">{{printsmodel.printvalue}}</TD>
				      </tr>
				      <TR class="top2">
					      <TD><span v-if="printsmodel.p_man==1">配货人</span></TD>
					      <TD><span v-if="printsmodel.s_man==1">送货人</span></TD>
					      <TD><span v-if="printsmodel.ss_man==1">收货人</span></TD>
					      <TD>&nbsp;</TD>
					      <TD>&nbsp;</TD>
				      </tr>
	      	      </TABLE>
		      	  
		      	  <div class="pageBreak"></div>
		      </div>
		  </div>
		  
	      <div slot="footer" class="dialog-footer">
	          <el-button @click="printerDialog = false">取 消</el-button>
	          <el-button type="danger" @click="printContent">打印</el-button>
	      </div>
  	  </el-dialog>
  	  <!--------------------------------打印信息 end--------------------------->
      
      <!---------------------------- 导出信息确认 ---------------------------->
      <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
      	  <div id="outputorder">
	      	  <el-table :data="outlists" border v-loading="outlistsLoading">
	      	  	  <el-table-column prop="documents" label="订单编号" width="90"></el-table-column>
	          	  <el-table-column prop="customer" label="客户名称"></el-table-column>
	          	  <el-table-column prop="district_name" label="所在区域"></el-table-column>
	          	  <el-table-column prop="clerk" label="销售员" align="center"></el-table-column>
	          	  <el-table-column prop="accountname" label="支付方式" align="center"></el-table-column>
	          	  <el-table-column prop="inputtime" label="下单时间" width="100" align="center"></el-table-column>
	          	  <el-table-column prop="verifytime" label="审核时间" width="100" align="center"></el-table-column>
	          	  <el-table-column prop="finishtime" label="完成时间" width="100" align="center"></el-table-column>
	          	  <el-table-column prop="num" label="总数量" align="center"></el-table-column>
	              <el-table-column prop="total" label="订单总价" align="center"></el-table-column>
	          	  <el-table-column prop="real" label="实付金额" align="center"></el-table-column>
	          	  <el-table-column prop="derate" label="优惠金额" align="center"></el-table-column>
	          	  <el-table-column prop="express" label="快递费" align="center"></el-table-column>
	          	  <el-table-column prop="amount" label="已付金额" align="center"></el-table-column>	          	  	          	  
	          	  <el-table-column prop="note" label="备注"></el-table-column>
	      	  </el-table>
      	  </div>
      	  <div slot="footer" class="dialog-footer">
	          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
	          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
	      </div>	                
      </el-dialog>      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //功能操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Stat/index",
      lists:[],
      listLoading:false,
      printerDialog:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        date:[],
        clerkid:'',
        customerid:'',
        account:'',
      },
      
      queryprint: {
      	act:'printlists',
      	token:this.$cookies.get('token'),
      	sellid:''
      },
      
      total_rows: 0,
      sellerLists:[],
      delDialog:false,
      delLoading:false,
      del:{
        act:'del',
        token:this.$cookies.get('token'),
        documents:'',
        total:'',
        account:'',
        id:'',
        type:''  //0整单   1单品
      },
      accountLists:[],
      printsmodel:[],
      print:[],
      customerlists:[],
      paylists:[],
      isselect:false,
      customerLoading:false,
      customerLists:[],
      
      prpage:[],
	  prollpage:[],
	  prtotal:0,
	  rollpage:'',
      allstat:[],
      outlistsLoading:false,
      outlists:[],
      outputDialog:false,
    }
  },
  mounted(){
    this.getSeller();
    this.getList();
    this.getactionauth();
    this.getprintsmodel();
    this.getcustomers();
    this.getpaylists();
    this.getAllstat();
  },
  methods:{
  
  	/** 获取功能权限  **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  
    //信息列表
    getList(){
      if(this.isselect==true) {
		  this.query.p=1;
		  this.query.rollpage=10;	    	
      }
    
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          this.getAllstat(); //重新计算订单金额和实付金额
        }
        
        if(this.isselect==true) this.isselect=false;
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
          if(this.isselect==true) this.isselect=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    //获取销售员
    getSeller(){
      var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 获取订单统计 **/
    getAllstat(){    
        var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.save({act:'getAllstat',clerkid:this.query.clerkid,customerid:this.query.customerid,date:this.query.date,account:this.query.account,documents:this.query.key,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
        }else{
            this.allstat = JSON.parse(Base64.decode(res.data.Data));
        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取银行帐户 **/
    getAccount(){
      var resource = this.$resource(this.GLOBAL.domain+"Account/index");
      resource.query({act:'lists',isdeposit:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    
    /** 订单撤单（异步检测商品的退款金额） **/
    delCurrent(item){      
        var resource = this.$resource(this.url);
        resource.save({act:'checkorderrefund',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            }else{
          	    var total = Base64.decode(res.data.Data);
                this.del.id=item.id;
		        this.del.documents=item.documents;
		        this.del.total=total;
		        if(item.account>0) this.del.account=item.account;
		        this.getAccount();
		        this.del.type=0;
		        this.delDialog=true;
          	}
        }).catch((res) => {

        });
      
    },
    
    
    /** 订单商品退货（异步检测商品的退款金额） **/
    returnCurrent(item){
      var resource = this.$resource(this.url);
      resource.save({act:'checkrefund',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          }else{
          	var total = Base64.decode(res.data.Data);
            this.del.id=item.id;
	        this.del.documents=item.name;
	        this.del.total=total;
	        this.getAccount();
	        this.del.type=1;
	        this.delDialog=true;
          }
      }).catch((res) => {

      });
    },
    
    
    /** 确认撤单 **/
    delSave(){
      this.delLoading=true;
      var resource = this.$resource(this.url);
      resource.save(this.del).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.delLoading=false;
          }else{
            this.$message.success(res.data.Message);
            this.delDialog=false;
            this.delLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.delDialog=false;
          this.delLoading=false;
      });
    },
    
    
    /** 订单打印预览 **/
    printCurrent(obj) {
    	this.queryprint.sellid=obj.id;
		var resource = this.$resource(this.GLOBAL.domain+"Sell/index");
        resource.save(this.queryprint).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          }else{
          	this.print = JSON.parse(Base64.decode(res.data.Data));
          	//设置打印分页显示信息
          	this.changepage(this.print.goods.length);
            this.printerDialog=true;
          }
        }).catch((res) => {

        });
    },
    
    
    /** 设置分页设置 **/
    changepage(count) {
    	var number=this.rollpage; //系统设置的每页条数
    	if(count > 0 ) this.prtotal=count;
    	this.prpage=[];
    	this.prollpage=[];
    	
    	if(number >= this.prtotal) {
    		this.prpage.push({id:1});
    		this.prollpage.push({startpage:0,endpage:number});
    		this.allprintpage=1;
    	}else {
    		var tnumber=parseInt(this.prtotal/number);
    		var lnumber=this.prtotal%number;
    		var index;
    		var start;
    		var end;
    		lnumber > 0 ? tnumber++ : '';
    		this.allprintpage=tnumber;
    		
    		for (var i=0;i<tnumber;i++) {
				index=i+1;
				this.prpage.push({id:index});
				start=i*number;
				end=index*number-1;
				this.prollpage.push({startpage:start,endpage:end});
			}
    	}
    },
    
    
    /** 获取打印模板设置 **/
    getprintsmodel() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'getmodelsetting',id:1,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
	            this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 打印确认单 **/
    printContent() {
    	var div_print=document.getElementById('printContent');
        var newStr=div_print.innerHTML;
        var oldStr=document.body.innerHTML;
        document.body.innerHTML=newStr;
        window.print();
        document.body.innerHTML=oldStr;
        location.reload();
    },
    
    
    /** 获取客户名称列表 **/
    getcustomers() {
    	var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	    resource.query({act:'lists',token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		    	this.customerlists = JSON.parse(Base64.decode(res.data.Data));
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    
    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },
    
    
    /** 支付方式列表 **/
    getpaylists() {
    	var _this=this;
    	var resource = this.$resource(this.GLOBAL.domain+"Account/index");
        resource.query({act:'lists',isdeposit:1,isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.paylists = JSON.parse(Base64.decode(res.data.Data));
	            this.paylists.forEach(function(e,index) {
	            	if(e.id==0) _this.paylists[index]['id']='01';
	            });
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改每页条数 **/
    changepagevlaue() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
	    resource.query({act:'changepagesize',id:88,num:this.rollpage,token:this.$cookies.get('token')}).then((res) => {
	    	if(res.data.Result>0){
		    	if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
	        }else{
		        this.changepage(this.print.goods.length);
	        }
	    }).catch((res) => {
	        //this.$message.error(this.GLOBAL.errortext);
	    });
    },
    
    date:[],
        clerkid:'',
        customerid:'',
        account:'',
    
    
    /** 导出当前销售订单 **/
    outputinfos() {
    	this.outlistsLoading=true;
    	this.outputDialog=true;
        var resource = this.$resource(this.url);
        resource.query({act:'getoutdata',clerkid:this.query.clerkid,date:this.query.date,customerid:this.query.customerid,account:this.query.account,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.outlistsLoading=false;
	        }else{
	            this.outlists = JSON.parse(Base64.decode(res.data.Data))
	            this.outlistsLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.outlistsLoading=false;
        });
    },
    
    /** 确认导出订单信息 **/
    sureoutput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var tHeader = ['订单编号','客户名称','所在区域','销售员','支付方式','下单时间','审核时间','完成时间','订单商品合计数量','订单总价','实付金额','优惠金额','快递费','已付金额','备注'];
			var filterVal = ['documents','customer','district_name','clerk','accountname','inputtime','verifytime','finishtime','num','total','real','derate','express','amount','note'];
				
			var list = this.outlists;
			var data = this.formatJson(filterVal, list);
			export_json_to_excel(tHeader, data, '销售订单列表');
			this.outputDialog=false;
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},
    
  }
}
</script>

<style>
@media print{
  .pageBreak{page-break-after: always;}
  .noPrint{display: none;}
}
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/stat/Order.vue